export default defineNuxtPlugin((nuxtApp) => {
  const showErrorNotification = (message, details = null) => {
    if (import.meta.env.DEV && details) {
      console.error('[Error Handler]', message, details)
    }

    if (window?.$nuxt) {
      window.$nuxt.$emit('show-notification', {
        type: 'error',
        title: 'Error',
        message: import.meta.env.DEV && details ? `${message}: ${details}` : message,
        duration: 5000,
      })
    }
  }

  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    console.error('[Vue Error Handler]', err, info)

    const componentName = instance?.$options?.name || instance?.$?.type?.name || 'Unknown Component'
    const errorMessage = err.message || 'An unexpected error occurred'

    showErrorNotification(
      import.meta.env.DEV
        ? `Error in ${componentName}`
        : 'Something went wrong. Please try refreshing the page.',
      import.meta.env.DEV ? errorMessage : null
    )
  }

  nuxtApp.hook('vue:error', (err, instance, info) => {
    console.error('[Vue Error Hook]', err, info)
  })

  nuxtApp.hook('app:error', (err) => {
    console.error('[App Error Hook]', err)

    showErrorNotification(
      import.meta.env.DEV
        ? 'Application Error'
        : 'Something went wrong. Please try refreshing the page.',
      import.meta.env.DEV ? err.message : null
    )
  })

  // Named handlers (NOT inline) so we can removeEventListener on HMR.
  // Without this, every Vite hot-reload of this plugin doubles the listener
  // count, and a single error fires the notification N times after N reloads.
  const onUnhandledRejection = (event) => {
    console.error('[Unhandled Promise Rejection]', event.reason)
    showErrorNotification(
      import.meta.env.DEV
        ? 'Async Error'
        : 'An operation failed. Please try again.',
      import.meta.env.DEV ? event.reason?.message : null
    )
    event.preventDefault()
  }

  const onWindowError = (event) => {
    if (event.error) {
      console.error('[Global Error Event]', event.error)
      showErrorNotification(
        import.meta.env.DEV
          ? 'Runtime Error'
          : 'An error occurred. Please try refreshing the page.',
        import.meta.env.DEV ? event.error.message : null
      )
    }
  }

  window.addEventListener('unhandledrejection', onUnhandledRejection)
  window.addEventListener('error', onWindowError)

  // Vite/Nuxt HMR — when this plugin module is hot-replaced, dispose the
  // listeners we registered on the previous instance.
  if (import.meta.hot) {
    import.meta.hot.dispose(() => {
      window.removeEventListener('unhandledrejection', onUnhandledRejection)
      window.removeEventListener('error', onWindowError)
    })
  }
})
